<template>
  <div :class="['form-element', hidden && 'd-none']">
    <FormLabel
      v-if="label"
      v-bind="{
        label,
        required,
        disabled,
        description,
        descriptionType,
        dirty,
        error,
        id
      }"
    />
    <div>
      <FormLabel
        label="Select Requirement Sets"
      />

      <div
        v-for="(item,i) in requisiteSet.value"
        :key="i"
        class="d-flex align-items-start"
      >

        <FormRequirementSetSelect
          v-model="requisiteSet.value[i]"
          :excludedIds="requisiteSet.value"
          :config="{...config, multiple:false }"
          placeholder="Type here to start searching"
          class="flex-1"
        />
        <AppTooltip>
          <AppButton
            v-if="i!==0"
            :raised="true"
            variant="danger"
            style="height:34px;"
            class="ml-2 px-2 rounded-5"
            data-test="delete_requisite_requisiteSet"
            @click="deleteValue(i)"
          >
            <AppIcon name="delete" />
          </AppButton>
          <template #tooltip>Delete</template>
        </AppTooltip>
        <AppTooltip>
          <AppButton
            v-if="i===0"
            :raised="true"
            style="height:34px;"
            class="ml-2 px-2 rounded-5"
            data-test="add_requisite_requisiteSet"
            @click="addNewValue"
          >
            <AppIcon name="add" />
          </AppButton>
          <template #tooltip>Add additional requirement sets</template>
        </AppTooltip>
      </div>
    </div>
    <AppButton
      :raised="true"
      :disabled="!currentSelections.length"
      class="mb-2"
      style="height:34px;"
      @click="addRequirementSet"
    >Add</AppButton>
    <section v-if="normalizedValue.length">
      <AppSortable
        :value="normalizedValue"
        keySuffix="cs"
        class="border rounded-5"
        @input="update"
      >
        <template #default="{ item: requisiteSet, key }">
          <div
            class="d-flex border-bottom pr-2 py-2 pl-3 align-items-center"
            title="Drag to sort"
          >
            <AppIcon
              name="drag_indicator"
              class="mr-2"
              style="opacity:0.5"
            />
            <div
              class="mr-2 flex-1"
              v-html="requisiteSet.value.map(getRequirementSetLabel).join(` </br><strong>${(requisiteSet.logic).toUpperCase()}</strong> `)"
            />
            <AppButton
              variant="danger"
              @click="deleteRequirementSet(key)"
            >
              <AppIcon name="clear" />
            </AppButton>
          </div>
        </template>
      </AppSortable>
    </section>
  </div>
</template>
<script>
import FormMixin from './FormMixin'
import FormLabel from './FormLabel'
import FormRequirementSetSelect from './FormRequirementSetSelect'
import { mapGetters } from 'vuex'
import _isObject from 'lodash/isObject'

export default {
  mixins: [ FormMixin ],
  components: { FormLabel, FormRequirementSetSelect },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data () {
    return {
      requisiteSet: {
        value: [ undefined ], // setting undefined so that the field shows up
        logic: 'and',
      },
    }
  },
  computed: {
    ...mapGetters('curriculumPrograms', [ 'requisiteSetById' ]),
    normalizedValue () { // Only used untill all data is updated to support and/or logic
      return this.value.map(v => _isObject(v) ? v : { value: [ v ], logic: 'and' })
    },
    currentSelections () {
      return this.requisiteSet.value.filter(Boolean)
    },
    unselectedLogic () {
      return [ 'and', 'or' ].find(logic => logic !== this.requisiteSet.logic)
    },
  },
  methods: {
    addNewValue () {
      this.requisiteSet.value.push(undefined)
    },
    deleteValue (index) {
      this.requisiteSet.value.splice(index, 1)
    },
    deleteRequirementSet (key) {
      this.$emit('input', this.normalizedValue.filter((requisiteSet, index) => index !== key))
    },
    addRequirementSet () {
      if (this.currentSelections.length) {
        this.$emit('input', [ ...this.normalizedValue, { ...this.requisiteSet, value: this.currentSelections } ])
        this.requisiteSet.value = [ undefined ]
      }
    },
    getRequirementSetLabel (requisiteSetId) {
      const requisiteSet = this.requisiteSetById(requisiteSetId)
      return `<span>${requisiteSet.name || 'Untitled Requirement Set'}</span>`
    },
  },
}
</script>
